import { gql } from '@apollo/client';

export default gql`
  mutation deleteDocEntry($_id: String) {
    deleteDocEntry(_id: $_id) {
      ok
      message
      error
    }
  }
`;
